"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Facebook, Linkedin, ArrowUp, MapPin, Phone, Mail, FileText } from "lucide-react";
const services = ["Ausiliari Tessili", "Materie Prime", "Strumenti di Laboratorio", "Macchinari Industriali"];
function FooterQuickLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <footer data-section-id="264899" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              
            </Link>
            <p className="text-muted-foreground text-xs font-mono leading-relaxed uppercase tracking-wider">
              Centro Chimica S.r.l. | Forniture industriali e chimiche per il distretto tessile di Prato dal 1978. Eccellenza tecnica e affidabilità B2B.
            </p>
          </div>

          {}
          <div>
            
            <MenuProvider menu_id="footer_menu">
              <FooterQuickLinks />
            </MenuProvider>
          </div>

          {}
          

          {}
          <div>
            <h3 className="font-default font-bold text-sm mb-6 text-foreground uppercase tracking-widest">Sede Legale</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground text-xs font-mono">
                <MapPin className="size-4 text-primary shrink-0 mt-0.5" />
                <span>Viale della Repubblica 298, Prato (PO)</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-xs font-mono">
                <Phone className="size-4 text-primary shrink-0" />
                <span>+39 0574 571234</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-xs font-mono">
                <Mail className="size-4 text-primary shrink-0" />
                <span>centrochimica@centrochimica.it</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-xs font-mono">
                <FileText className="size-4 text-primary shrink-0" />
                <span>P.IVA: 04492810488</span>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-muted-foreground/60 text-[10px] font-mono text-center md:text-left uppercase tracking-tighter">
            &copy; 1978-{new Date().getFullYear()} Centro Chimica S.r.l. Tutti i diritti riservati.
          </p>
          
          <div className="flex items-center gap-4">
            {}
          </div>

          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-md border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300" aria-label="Torna su">
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </footer>;
}